import { useQuery } from "@tanstack/react-query";
import { getMobilityDetail } from "../api/mobility";
import { DeleteAdmin } from "../types/types";

const useGetMobilityDetail = ({ idx }: DeleteAdmin, enabled: boolean) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["MobilityDetail", `idx-${idx}`],
    queryFn: () => getMobilityDetail({ idx }),

    staleTime: 0,
    retry: false,
    enabled,
  });

  return { data, isLoading, isSuccess };
};

export default useGetMobilityDetail;
